import PropTypes from 'prop-types';

export const ServiceItemLocationSettingPropType = PropTypes.shape({
  locationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  displayOnLocationPage: PropTypes.bool,
});
